module.exports = __webpack_public_path__ + "img/add-alt.5c48eeb3.svg";